export enum TafaceBusinessTypeEnum {
  GENERIC_PLAZA = 'GENERIC_PLAZA',
  STORE_PLAZA = 'STORE_PLAZA',
  LITERAL_E = 'LITERAL_E',
  RESTAURANT = 'RESTAURANT',
}
